// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2x6fe","alert":"SettungsInbox_alert__jIcvW"};